import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import type { UserRolesRequest, UserRolesResponse } from 'vopay';

const { api } = vopayApi;

export default function useFetchUserRoles() {
  const source = axios.CancelToken.source();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<UserRolesResponse | undefined>();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function fetchUserRoles(requestParams: UserRolesRequest): Promise<UserRolesResponse> {
    try {
      setLoading(true);

      const res = await api.fetchUserRoles(requestParams, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setResponse(res);
      return res;
    } catch (err) {
      console.error('Fetch user roles failed:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    response,
    fetchUserRoles,
  };
}
